const parseCookieString = (cookieString: string): Record<string, string> => {
  const out: Record<string, string> = {};
  if (!cookieString) return out;

  const parts = cookieString.split(";");
  for (const part of parts) {
    const [rawName, ...rest] = part.trim().split("=");
    if (!rawName) continue;
    const rawValue = rest.join("=");
    // best-effort decode (cookie values are often URI encoded)
    try {
      out[rawName] = decodeURIComponent(rawValue || "");
    } catch {
      out[rawName] = rawValue || "";
    }
  }
  return out;
};

export const getCookieSnapshot = (cookieString: string) => {
  const values = parseCookieString(cookieString);

  const openedFromApkRaw =
    values["is_opened_from_apk"] ?? values["isOpenedFromApk"] ?? "";
  const isOpenedFromApk =
    typeof openedFromApkRaw === "string" &&
    openedFromApkRaw.toLowerCase() === "true";

  // Your requirement says `gpsAdid`, but existing code uses `gps_adid`.
  // Support both.
  const gpsAdid =
    values["gpsAdid"] ??
    values["gps_adid"] ??
    values["gpsAdid".toLowerCase()] ??
    "";

  return {
    raw: cookieString || "",
    isOpenedFromApk,
    gpsAdid,
    values,
  };
};

